import React, { useState, useEffect } from "react";
import Select from "../ui/Select";
import TabelaChamados from "./TabelaChamados/TabelaChamados";

const todosMeses = [
  "Janeiro", "Fevereiro", "Março", "Abril",
  "Maio", "Junho", "Julho", "Agosto",
  "Setembro", "Outubro", "Novembro", "Dezembro"
];

export default function ChamadosPorCliente() {
  const [mes, setMes] = useState("todos");
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Buscar dados da API
  useEffect(() => {
    const fetchDados = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/Dashboard/cliente.php?mes=${mes}&limite=10`
        );
        const json = await response.json();
        console.log("Resposta da API (clientes top):", json);

        if (json.success) {
          setDados(json.dados);
        }
      } catch (error) {
        console.error("Erro ao carregar clientes:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDados();
  }, [mes]);

  const opcoesMes = [
    { value: "todos", label: "Todos os Meses" },
    ...todosMeses.map((m) => ({ value: m, label: m })),
  ];

  if (loading) {
    return <p className="p-6">Carregando dados...</p>;
  }

  return (
    <div className="p-6 bg-white rounded-sm shadow-md shadow-black/20 space-y-4">
      {/* Cabeçalho */}
      <div className="flex items-center justify-between">
        <h3
          className="font-bold"
          style={{
            fontFamily: '"Source Sans Pro", sans-serif',
            fontSize: "14px",
            color: "#777777",
          }}
        >
          Top Clientes com Mais Chamados
        </h3>

        <div className="w-44">
          <Select value={mes} onChange={setMes} options={opcoesMes} />
        </div>
      </div>

      {/* 🔹 Agora a tabela sabe se deve mostrar ou esconder a coluna Mês */}
      <TabelaChamados dados={dados} mes={mes} />
    </div>
  );
}
